import * as types from './../types/categoria_arquivos';

const INITIAL_STATE = {
  loading: false,

  categorias: [],

};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.SET_CATEGORIA:
      return { ...state, categorias: action.payload };

    case types.LOADING_CATEGORIAS:
      return { ...state, loading: action.payload };

    default:
      return state;
  }
};